<template>
  <List showArchived />
</template>

<script lang="ts" setup>
import List from './List.vue'
</script>
